import { BreadcrumbItem } from 'components/breadcrumb/breadcrumbModel';
import {
  buildPathFromSegments,
  buildSegmentsFromPath,
  createSectionBreadcrumb,
  optimizeBreadcrumbPaths,
  applyNaturalExceptions,
} from 'components/breadcrumb/breadcrumbHelper';
import { COMPOUND_BREADCRUMB_RULES, NATURAL_BREADCRUMB_EXCEPTIONS } from 'components/breadcrumb/breadcrumbRules';

function ensureFirstBreadcrumbIsAbsolute(breadcrumbs: BreadcrumbItem[]): BreadcrumbItem[] {
  if (breadcrumbs.length === 0) return breadcrumbs;

  const firstBreadcrumb = breadcrumbs[0];

  if (!firstBreadcrumb.path.startsWith('/')) {
    return [
      {
        ...firstBreadcrumb,
        path: `/${firstBreadcrumb.path}`,
      },
      ...breadcrumbs.slice(1),
    ];
  }

  return breadcrumbs;
}

function buildFlatBreadcrumbs(segments: string[]): BreadcrumbItem[] {
  if (segments.length === 0) return [];

  const breadcrumbs: BreadcrumbItem[] = [];
  let i = 0;

  while (i < segments.length) {
    const currentSegment = segments[i];
    const isCompoundSegment = (COMPOUND_BREADCRUMB_RULES as string[]).includes(currentSegment);

    let breadcrumb: BreadcrumbItem;

    if (isCompoundSegment && i + 1 < segments.length) {
      breadcrumb = createSectionBreadcrumb([currentSegment, segments[i + 1]], COMPOUND_BREADCRUMB_RULES);
      i += 2;
    } else {
      const pathSegments = segments.slice(0, i + 1);
      breadcrumb = {
        path: buildPathFromSegments(pathSegments),
      };
      i += 1;
    }

    breadcrumbs.push(breadcrumb);
  }

  const orderedBreadcrumbs = applyNaturalExceptions(
    breadcrumbs,
    NATURAL_BREADCRUMB_EXCEPTIONS,
    COMPOUND_BREADCRUMB_RULES
  );

  const optimized = optimizeBreadcrumbPaths(orderedBreadcrumbs);

  return ensureFirstBreadcrumbIsAbsolute(optimized);
}

export function generateBreadcrumbsFromPath(pathname?: string): BreadcrumbItem[] {
  const currentPath = pathname ?? window.location.pathname;
  const segments = buildSegmentsFromPath(currentPath);

  if (segments.length === 0) {
    return [];
  }

  return buildFlatBreadcrumbs(segments);
}
